export default "__VITE_ASSET__Dmn$8K4y__"